import React from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from "../../I18n/components/companyMarket";
import PackageManager from "../PackageManager/PackageManager";

const PackageManagerModal = (props) => {
	return (
		<Modal className="package-manager-modal" isOpen={props.packageManagerModal} toggle={props.packageManagerToggle}>
			<ModalHeader toggle={props.packageManagerToggle}>{I18n[props.lang].packManager}</ModalHeader>
			<ModalBody>
				<PackageManager close={props.packageManagerToggle}/>
			</ModalBody>
		</Modal>
	)
};

export default PackageManagerModal;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/PackageManagerModal.js